const pages = {
  all: '/workspaces/(.*)?',
  index: '/workspaces',
  selection: '/workspaces/selection',
};

export default pages;
